/* eslint-disable import/prefer-default-export */
import { formatDate, generateRandomUniqueId } from '@/helpers';

export const userInfoLocalize = user => ({
    _id: generateRandomUniqueId(),
    name: user?.user_info?.legal_name ?? user.name,
    idType: user.user_info?.id_type
        ? {
            id: user.user_info.id_type?.id,
            name: user.user_info.id_type?.name,
        }
        : undefined,
    nric: user.user_info
        ? user.user_info.NRIC
        : undefined,
    nationality: user.user_info
        ? { 
            value: user.user_info.nationality?.id,
            text: user.user_info.nationality?.name
        }
        : undefined,
    dateOfExpiry: formatDate(user.user_info?.date_of_expiry),
    dob: user.user_info
        ? formatDate(user.user_info.DOB)
        : undefined,
    email: user.email,
    contactNumber: user.user_info
        ? user.user_info.contact_number
        : undefined,
    address: user.user_info
        ? user.user_info.address
        : undefined,
});
